import { getActiveClient } from './active-session'

// Calls the frm-billing edge function (JWT auto-attached by the supabase client). It is inert (503
// → 'billing_not_configured') until the Stripe secrets are set, so the UI degrades gracefully.
async function invoke(action: 'checkout' | 'portal'): Promise<{ url?: string; error?: string }> {
  const { data, error } = await (await getActiveClient()).functions.invoke('frm-billing', {
    body: { action },
  })
  if (error) {
    // 503 before keys are set, or network — surface a friendly state
    return { error: 'unavailable' }
  }
  if (data?.error) return { error: data.error }
  if (data?.url) return { url: data.url as string }
  return { error: 'no_url' }
}

/** Start Stripe Checkout for the Pro subscription; redirects on success. */
export async function startCheckout(): Promise<{ error?: string }> {
  const r = await invoke('checkout')
  if (r.url) {
    window.location.href = r.url
    return {}
  }
  return { error: r.error }
}

/** Open the Stripe billing portal to manage/cancel the subscription. */
export async function openPortal(): Promise<{ error?: string }> {
  const r = await invoke('portal')
  if (r.url) {
    window.location.href = r.url
    return {}
  }
  return { error: r.error }
}

/**
 * Mint a FreightRates Pro API key (frm_) for the signed-in, entitled org, via the frm-issue-key
 * edge function. Returns the plaintext key ONCE. Requires an active freightrates entitlement (402
 * otherwise); the key is what the rates API and MCP server authenticate.
 */
export async function issueApiKey(): Promise<{ key?: string; error?: string }> {
  const { data, error } = await (await getActiveClient()).functions.invoke('frm-issue-key', {
    body: {},
  })
  if (error) return { error: 'unavailable' }
  if (data?.ok && data.key) return { key: data.key as string }
  return { error: (data?.message as string) || (data?.error as string) || 'could_not_issue' }
}
